import React, { useState, useEffect } from "react";
import Layout from '../components/layout/Layout';
import API from '../utils/api';

const Appointments = () => {
  const [formData, setFormData] = useState({
    physician: '',
    date: '',
    time: '',
    notes: ''
  });
  const [physicians, setPhysicians] = useState([]);
  const [message, setMessage] = useState('');
  const [zoomLink, setZoomLink] = useState('');
  const [error, setError] = useState('');

  // Fetch physicians
  useEffect(() => {
    API.get('/api/physicians') // ⬅️ use API
      .then((res) => setPhysicians(res.data))
      .catch((err) => {
        console.error("❌ Failed to fetch physicians:", err);
        setError('Unable to load physicians.');
      });
  },  []);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

// Submit appointment
const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');
  setMessage('');
  setZoomLink('');

  try {
    const token = JSON.parse(localStorage.getItem("user"))?.token;

    const res = await API.post('/api/appointments', formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    setMessage("✅ Appointment booked successfully!");
    setZoomLink(res.data.zoomJoinUrl);
    setFormData({
      physician: '',
      date: '',
      time: '',
      notes: ''
    });
  } catch (err) {
    console.error("❌ Appointment error:", err.response?.data || err.message);
    if (err.response?.status === 401) {
      setError("⚠️ Please create an account or log in to book an appointment.");
    } else {
      setError("Something went wrong while booking your appointment.");
    }
  }
};

  return (
    <Layout>
      <div className="container py-5">
        <h2 className="mb-4">Schedule an Appointment</h2>
        <p>Select a date and time that works for you. If you're a new patient, you'll be asked a few questions to help us match you with the right physician.</p>

        {error && <div className="alert alert-danger">{error}</div>}
        {message && <div className="alert alert-success">{message}</div>}
        {zoomLink && <div className="alert alert-info">📅 Your Zoom link: <a href={zoomLink} target="_blank" rel="noopener noreferrer">Join Session</a></div>}

        <form onSubmit={handleSubmit} className="mt-4">
          {/* Physician Dropdown */}
          <div className="mb-3">
            <label>Select Physician</label>
            <select
              name="physician"
              value={formData.physician}
              onChange={handleChange}
              className="form-select"
              required
            >
              <option value="">-- Select --</option>
              {physicians.map((doc) => (
                <option key={doc._id} value={doc._id}>
                  {doc.name}
                </option>
              ))}
            </select>
          </div>

          {/* Date */}
          <div className="mb-3">
            <label>Date</label>
            <input
              type="date"
              name="date"
              className="form-control"
              value={formData.date}
              onChange={handleChange}
              required
            />
          </div>

          {/* Time */}
          <div className="mb-3">
            <label>Time</label>
            <input
              type="time"
              name="time"
              className="form-control"
              value={formData.time}
              onChange={handleChange}
              required
            />
          </div>

          {/* Notes */}
          <div className="mb-3">
            <label>Notes (Optional)</label>
            <textarea
              name="notes"
              className="form-control"
              value={formData.notes}
              onChange={handleChange}
              rows={3}
              placeholder="e.g., I'm a new patient"
            />
          </div>

          <button type="submit" className="btn btn-primary w-100">
            Book Appointment
          </button>
        </form>
      </div>
    </Layout>
  );
};

export default Appointments;
